function edit_meal_open({ meal_id, setEditMeal }) {
    const url = new URL(window.location.href);
    // Create an instance of URLSearchParams from the current query parameters
    const params = new URLSearchParams(url.search);
    // Add or update query parameters
    params.set('edit_meal_id', meal_id);
    // Set the updated search parameters back to the URL
    url.search = params.toString();
    // Optionally update the browser's address bar without reloading the page
    window.history.replaceState(null, '', url.toString());
    setEditMeal(true)
}

export default edit_meal_open;